<div class="ppLogin_content">
  <div class="ppLogin_body">
    <form [formGroup]="emailConfirmationForm" (ngSubmit)="continue()">
      <div class="loginBody-content">
        <div class="headerWithBack" style="display: ruby-text;">
          <div class="ppLogin_header">
            <i class="icon-backarrow" (click)="goBack()"></i>
          </div>
          <h1 class="loginTitle">{{ 'MODULES.LOGIN.CONFIRM_YOUR_EMAIL_ADDRESS' | transloco }}</h1>
        </div>
        <p class="loginDescription">
          {{ 'MODULES.LOGIN.EMAIL_CONFIRMATION_DESCRIPTION' | transloco }}
        </p>

        <div class="dsFieldWrap" [ngClass]="{ 'dsFieldError': email?.invalid && (email?.dirty || email?.touched) }">
          <div class="dsLabel">{{ 'MODULES.LOGIN.EMAIL_ADDRESS' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input formControlName="email" matInput type="email" required maxlength="100" />
          </mat-form-field>
          <div class="dsErrorMsg" *ngIf="email?.invalid && (email?.dirty || email?.touched)">
            <span *ngIf="email?.errors?.['required']">{{ 'MODULES.LOGIN.EMAIL_FIELD_EMPTY' | transloco }}</span>
            <span *ngIf="email?.errors?.['email'] || email?.errors?.['pattern']">{{ 'MODULES.LOGIN.INVALID_EMAIL' |
              transloco }}</span>
          </div>
        </div>

        <div class="dsFieldWrap"
          [ngClass]="{ 'dsFieldError': password?.invalid && (password?.dirty || password?.touched) }">
          <div class="dsLabel">{{ 'MODULES.LOGIN.PASSWORD' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" matInput required />
            <span (click)="showPassword = !showPassword" class="eye loginIcon"
              [ngClass]="{ 'icon-pswdHide': !showPassword, 'icon-pswdShow': showPassword }"></span>
          </mat-form-field>
          <div class="dsErrorMsg" *ngIf="password?.errors?.['required'] && (password?.dirty || password?.touched)">
            <span>{{ 'MODULES.LOGIN.NEW_PASSWORD_FIELD_EMPTY' | transloco }}</span>
          </div>
          <div class="dsErrorMsg" *ngIf="password?.errors?.['minlength'] && (password?.dirty || password?.touched)">
            <span>{{ 'MODULES.LOGIN.PASSWORD_MIN_LENGTH' | transloco }}</span>
          </div>
          <div class="dsErrorMsg multiLineError" *ngIf="!password?.errors?.['minlength'] && password?.errors?.['pattern'] && (password?.dirty || password?.touched)">
            <span>{{ 'MODULES.LOGIN.NEW_PASSWORD_FORM' | transloco }}</span>
          </div>
        </div>

        <div class="dsFieldWrap"
          [ngClass]="{ 'dsFieldError': (confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)) || (emailConfirmationForm.errors?.['passwordMismatch'] && confirmPassword?.touched) }">
          <div class="dsLabel">{{ 'MODULES.LOGIN.CONFIRM_PASSWORD' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" matInput
              required />
            <span (click)="showConfirmPassword = !showConfirmPassword" class="eye loginIcon"
              [ngClass]="{ 'icon-pswdHide': !showConfirmPassword, 'icon-pswdShow': showConfirmPassword }"></span>
          </mat-form-field>
          <div class="dsErrorMsg"
            *ngIf="confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)">
            <span *ngIf="confirmPassword?.errors?.['required']">{{ 'MODULES.LOGIN.CONFIRM_PASSWORD_FIELD_EMPTY' |
              transloco }}</span>
          </div>
          <div class="dsErrorMsg"
            *ngIf="emailConfirmationForm.errors?.['passwordMismatch'] && confirmPassword?.touched && !confirmPassword?.errors?.['required']">
            <span>{{ 'MODULES.LOGIN.PASSWORDS_DO_NOT_MATCH' | transloco }}</span>
          </div>
        </div>
      </div>

      <footer class="loginBody-footer">
        <button type="submit" class="loginAction_btn" [disabled]="!emailConfirmationForm.valid">
          {{ 'MODULES.LOGIN.CONTINUE' | transloco }}
        </button>
      </footer>
    </form>
  </div>
  <div class="login-copyright">
    {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
  </div>
</div>